module.exports = __webpack_public_path__ + "img/06.b1f40b46.png";